import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ParallaxProvider } from "react-scroll-parallax";
import { HelmetProvider } from "react-helmet-async"; // 1. Importe o provider

import "./css/themify-icons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ParallaxProvider>
        <App />
      </ParallaxProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
